import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Shift } from '../domain/shift';
import { DEFAULT_FRAME_RATE } from '../domain/video';
import { Track } from '../services/track';
import { PlayerThumbnail } from '../shared/player-track-thumbnails/player-track-thumbnails.component';
import { videoTimeExternalChange } from '../state/actions/game.action';
import { GlobalState } from '../state/reducers';

@Component({
  selector: 'app-shift-panel',
  templateUrl: './shift-panel.component.html',
  styleUrls: ['./shift-panel.component.css']
})
export class ShiftPanelComponent {
  _tracks: Track[] = [];
  selectedTrackIndex = 0;

  @Input() shift: Shift;
  @Input() thumbnails: PlayerThumbnail[] = [];
  @Input() frameRate = DEFAULT_FRAME_RATE;

  @Output() selectedTrackChange = new EventEmitter<number>();
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  constructor(private store: Store<GlobalState>) {}

  @Input()
  set tracks(tracks: Track[]) {
    this._tracks = tracks;
    this.selectedTrackIndex = 0;
  }

  get tracks() {
    return this._tracks;
  }

  get selectedTrack(): Track {
    return this.tracks[this.selectedTrackIndex];
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') {
      event.stopPropagation();
      this.selectTrack(
        (this.selectedTrackIndex - 1 + this.tracks.length) % this.tracks.length
      );
    } else if (event.key === 'ArrowRight') {
      event.stopPropagation();
      this.selectTrack(
        (this.selectedTrackIndex =
          (this.selectedTrackIndex + 1) % this.tracks.length)
      );
    } else if (event.key === 'Enter') {
      event.stopPropagation();
      this.confirmShift();
    } else if (event.key === 'Escape') {
      event.stopPropagation();
      this.hideThumbnails();
    }
  }

  frameNumberToVideoTime(frameNumber: number) {
    return frameNumber / (this.frameRate ?? 25);
  }

  calcTrackLeft(track: Track, shift: Shift) {
    const trackStartSec = track.start / (this.frameRate ?? 25);
    const trackStartOffset = trackStartSec - shift.onEvent.videoTime;
    const shiftVideoDuration =
      shift.offEvent.videoTime - shift.onEvent.videoTime;
    const trackStartPercentage = (trackStartOffset / shiftVideoDuration) * 100;
    return Math.round(trackStartPercentage) + '%';
  }

  calcTrackWidth(track: Track, shift: Shift) {
    const trackDurationSec = (track.end - track.start) / (this.frameRate ?? 25);
    const shiftVideoDuration =
      shift.offEvent.videoTime - shift.onEvent.videoTime;
    const trackDurationPercentage =
      (trackDurationSec / shiftVideoDuration) * 100;
    return Math.round(trackDurationPercentage) + '%';
  }

  selectTrack(trackIndex: number) {
    this.selectedTrackIndex = trackIndex;
    this.selectedTrackChange.emit(trackIndex);
  }

  seekVideo(videoTime: number) {
    this.store.dispatch(
      videoTimeExternalChange({
        videoTimeExternal: videoTime,
        random: self.crypto.randomUUID()
      })
    );
  }

  hideThumbnails() {
    this.cancel.emit();
  }

  confirmShift() {
    this.confirm.emit();
  }
}
